import { render, staticRenderFns } from "./homeWorkList.vue?vue&type=template&id=595487e2&scoped=true"
import script from "./homeWorkList.vue?vue&type=script&lang=js"
export * from "./homeWorkList.vue?vue&type=script&lang=js"
import style0 from "./homeWorkList.vue?vue&type=style&index=0&id=595487e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595487e2",
  null
  
)

export default component.exports